import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import DataTable from "../../components/Datatable/DataTable";
import MemberShow from "../Members/MemberShow/MemberShow";

import { showMemberRegisterOriginDetails } from "../../store/ducks/memberRegisterOrigin/actions";
import { filterErrorHandler, numFormat } from "../../hoc/Shared/utility";

class MemberRegisterOriginDetail extends Component {
    constructor(props){
        super(props);
        this.state = {
            data: [],
            member: [],
            loading: true,
            page: 1,
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalPages: 0,
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            order: null,
            totalRecords: 0,
            searchValue: "",
            pageShow: "listing",
            redirectParam: {}
        }
    }

    componentDidMount(){
        const data = this.getFilterList();
        
        if(this.props.detailsParam){
            this.props.showMemberRegisterOriginDetails(data);
        }

    }

    shouldComponentUpdate(nextProps, nextState){
        if(nextProps.show_member_register_origin_details_data !== undefined && nextProps.show_member_register_origin_details_data !== this.props.show_member_register_origin_details_data){
            if(nextProps.show_member_register_origin_details_data.data.responseCode === 200 && nextProps.show_member_register_origin_details_data.data.msgType === "success"){
                this.setState({
                    loading: false,
                    data: nextProps.show_member_register_origin_details_data.data.data.row,
                    totalPages: nextProps.show_member_register_origin_details_data.data.data.pagination.total_page,
                    totalRecords: nextProps.show_member_register_origin_details_data.data.data.pagination.total_record
                });
            }else{
                this.setState({
                    loading: false,
                    totalPages: 0,
                    activePage: 1,
                    totalRecords: 0,
                    data: []
                }, () => 
                {
                    filterErrorHandler(nextProps.show_member_register_origin_details_data.data.message);
                });
            }
        }

        return true;
    }

    getFilterList = () => {
        const listingArr = {};

        let availablePage = this.state.activePage;
        if (this.state.totalRecords > 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            this.state.activePage >= availablePage && this.setState({ activePage: availablePage });
        }

        listingArr.register_origin = this.props.detailsParam.registerOrigin;
        listingArr.country_id = this.props.currentUser.country_id;
        listingArr.page = this.state.activePage >= availablePage ? availablePage : this.state.activePage;
        listingArr.limit = this.state.limit;
        listingArr.search = this.state.searchValue;
        listingArr.order = JSON.stringify(this.state.order);

        this.setState({
            loading: true,
            data: []
        });
        return listingArr;
    }

    onSort = (field, order) => {
        const orderArry = [{}];
        let orderSequence = (order === 'asc') ? true : false;

        orderArry[0]['id'] = field;
        orderArry[0]['desc'] = orderSequence;

        this.setState({
            order: orderArry,
            loading: true,
            data: []
        }, () => {
            const data = this.getFilterList();
            this.props.showMemberRegisterOriginDetails(data);
        });
    }

    datatablesChangeHandler = (val, act) => {
        let search = "";
        search = (act === 'searchValue') ? val.target.value : val;

        this.setState({
            [act]: search,
            loading: true,
            data: []
        }, () => {
            const data = this.getFilterList();
            this.props.showMemberRegisterOriginDetails(data);
        });
    }

    noFormatter = (cell, row, rowIndex) => {
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit))
        return <span>{rowNumber}</span>;
    };

    changePageHandler = (page) => {
        this.setState({
            pageShow: page
        });
    }

    redirectHandler = (e, id, name) => {
        e.preventDefault();
        this.setState({
            pageShow: "redirect",
            redirectParam: {
                id: id,
                name: name
            }
        });
    }

    render(){
        const { t } = this.props;
        const columns = [
            { text: t('global.no'), dataField: 'no', formatter: this.noFormatter, headerStyle: { width: '60px', textAlign: 'center' } },
            { text: t("member-register-origin.username"), dataField: 'username', sort: true, onSort: (field, order) => this.onSort(field, order) },
            { text: t("member-register-origin.register-time"), dataField: 'registration_date', sort: true, onSort: (field, order) => this.onSort(field, order) },
            { text: t("member-register-origin.total-deposit-count"), dataField: 'total_deposit_count', sort: true, onSort: (field, order) => this.onSort(field, order) },
            { text: t("member-referral.total-deposit-amt"), dataField: 'total_deposit_amount', sort: true, onSort: (field, order) => this.onSort(field, order) }
        ];
        let data = this.state.data ? this.state.data.map((val, idx) => {
            let permission = this.props.currentUser.permission ?? [];
            let username = permission.includes("member_view") ? (
                <b>
                    <a href="/#" onClick={(event) => this.redirectHandler(event, val.id, val.username)}>
                        {val.username}
                    </a>
                </b>
            ) : val.username;
            const num_format = numFormat(val.currency);

            return {
                no: idx,
                username: username,
                registration_date: val.registration_date,
                total_deposit_count: val.total_deposit_count,
                total_deposit_amount: new Intl.NumberFormat("en-US", num_format).format(val.total_deposit_amount),
            }
        }) : [];

        return (
            <Auxiliary>
                {this.state.pageShow === "listing" && (
                <>
                    <div className='breadcrumb-header'>
                        <div className='d-flex'>
                            <div>
                                <div className="btn-group">
                                    <Button typeButton='button' classValue='btn btn-back-outline' idValue='back' buttonName={<i className="angle fe fe-chevron-left"></i>} clicked={() => this.props.changePageHandler(this.props.detailsParam.returnPage)} />
                                    <div>
                                        <div className="member-name">
                                            <FontAwesomeIcon icon={faUser} /> {this.props.detailsParam.registerOrigin}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row row-sm'>
                        <div className='col-lg-12 col-xl-12 col-md-12 col-sm-12'>
                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <h4 className='card-title mg-b-0'>{t('member-register-origin.register-origin')}</h4>
                                </div>
                                <div className="card-body pt-0">
                                    {this.state.loading ? <Skeleton count={3} /> :
                                    <table className='table table-bordered table-hover'>
                                        <tbody>
                                            <tr>
                                                <th>{t('member-register-origin.register-origin')}</th>
                                                <td>{this.props.detailsParam.registerOrigin}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    }
                                </div>
                            </div>

                            <div className='card box-shadow-0'>
                                <div className='card-header'>
                                    <h4 className='card-title mb-1'>{t(`member-register-origin.member-register-origin-details`)}</h4>
                                </div>
                                <div className='card-body'>
                                    <DataTable
                                        keyField='no'
                                        data={data}
                                        columns={columns}
                                        activePage={this.state.activePage}
                                        limit={this.state.limit}
                                        totalItems={this.state.totalRecords}
                                        paginationHandler={(val) => this.datatablesChangeHandler(val, 'activePage')}
                                        sizePerPageHandler={(val) => this.datatablesChangeHandler(val, 'limit')}
                                        searchChangeHandler={(val) => this.datatablesChangeHandler(val, 'searchValue')}
                                        searchValue={this.state.searchValue}
                                        classValue='dataTable table-bordered text-justify text-center'
                                        loading={this.state.loading}
                                        hideSearchBar={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                )}

                {this.state.pageShow === "redirect" && (
                    <MemberShow 
                        memberShowId={this.state.redirectParam.id}
                        memberShowUsername={this.state.redirectParam.name}
                        changePageHandler={(page) => this.changePageHandler(page)}
                        permission={this.props.currentUser.permission ?? []}
                        memberShowCount={0}
                    />
                )}
            </Auxiliary>
        )
    }
}

const mapStateToProps = state => {
    return {
        show_member_register_origin_details_data: state.memberRegisterOrgin.show_member_register_origin_details_data,
        currentUser: state.currentUser.data
    }
}

const mapDispatchToProps = {
    showMemberRegisterOriginDetails
}

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(MemberRegisterOriginDetail));